<template>
  <transition name="fade">
    <div v-if="show" class="sanitas-popup">
      <div class="sanitas-popup__background"></div>
      <div class="sanitas-popup--content" :class="computeDialogClass">
        <dotcom-icon
          v-if="closeIcon"
          name="xmark"
          art="light"
          color="--c-secondary-neutral-2"
          hover-color="--c-secondary-neutral-2"
          @click="$emit('close')"
        />
        <span id="content-slot">
          <slot></slot>
        </span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SanitasPopup',
  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },
  props: {
    closeIcon: Boolean,
    show: Boolean,
  },
  data: () => ({}),
  computed: {
    computeDialogClass() {
      return this.closeIcon ? 'has-close-icon' : ''
    },
  },
}
</script>

<style lang="postcss" scoped>
.sanitas-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: calc(var(--z-index-overlay) - 1);
  overflow: auto;

  &--content {
    position: relative;
    box-sizing: border-box;

    border: 1px solid var(--c-primary-neutral-2);
    background-color: var(--c-primary-neutral-3);

    padding: 30px;
    margin: 10vh auto;
    min-width: 66%;
    max-width: 66%;
    border-radius: var(--border-radius);

    & >>> .dotcom-icon {
      float: right;
      cursor: pointer;
      font-size: 24px;
    }

    @media (max-width: 544px) {
      min-height: 100%;
      min-width: 100%;
      max-width: 100%;
      margin: 0 auto;
      border-radius: 0;
    }
  }
}

.sanitas-popup__background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--c-primary-neutral-1);
  opacity: 0.85;
}
</style>
